import { FaUsers, FaUsersCog, FaShieldAlt } from "react-icons/fa";
import images from "./images";

const pricing = [
  {
    id: 1,
    image: images.plan1,
    icon: <FaUsers />,
    title: 'Basic Plan',
    content: 'For Small Teams',
    price: 19.99,
    unit: 'month',
    features: [
      'Access to AI Tools',
      'Up to 5 Users',
      'Basic Analytics',
      'Email Support',
      'No Customization',
    ],
  },
  {
    id: 2,
    image: images.plan2,
    icon: <FaUsersCog />,
    title: 'Standard Plan',
    content: 'For Growing Teams',
    price: 49.99,
    unit: 'month',
    features: [
      'Access to AI Tools',
      'Up to 20 Users',
      'Advanced Analytics',
      'Priority Email Support',
      'Limited Customization',
    ],
  },
  {
    id: 3,
    image: images.plan3,
    icon: <FaShieldAlt />,
    title: 'Premium Plan',
    content: 'For Enterprise Solutions',
    price: 99.99,
    unit: 'month',
    features: [
      'Access to All AI Tools',
      'Unlimited Users',
      'Advanced Analytics & Reporting',
      '24/7 Premium Support',
      'Full Customization',
    ],
  },
];

export default pricing;